import { r as registerInstance, h } from './index-4ec8feae.js';

const somFooterCss = ".footer{padding:0.5rem 1rem;margin-left:auto;margin-right:auto;background:#1d2528;display:flex;justify-content:space-between;color:#ffffff;font-size:0.75rem}.footer.light{background-color:#f7f7f7;color:#1d2528}.footer.light a{color:#1d2528}.footer__copyright{padding:0.5rem 1rem}.footer__copyright a{text-decoration:none;color:#ffffff}.footer__copyright a:hover{text-decoration:underline}.footer__nav{display:flex;flex-wrap:wrap}@media (max-width: 991.98px){.footer{flex-direction:column;justify-content:center;align-content:center;align-items:center}}";

let SomFooter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /**
     * Determines whether to use the light or dark theme. Dark is the default but adding the light parameter will switch it to the light theme.
     */
    this.light = false;
  }
  render() {
    return (h("footer", { class: `footer ${this.light ? 'light' : ''}`, role: "contentinfo", "aria-label": "footer" }, h("div", { class: "footer__copyright" }, "Copyright ", new Date().getFullYear(), ' ', h("a", { href: "http://www.michigan.gov", target: "_blank", rel: "noopener noreferrer" }, "State of Michigan")), h("div", { role: "list", class: "footer__nav" }, h("slot", null), h("som-footer-item", { "show-divider": "false" }, h("a", { target: "_blank", href: "https://www.michigan.gov/policies", rel: "noopener noreferrer" }, "Policies")))));
  }
};
SomFooter.style = somFooterCss;

export { SomFooter as som_footer };
